module.exports = __webpack_public_path__ + "img/virtual_tour.18c8f029.jpg";